import { AppointmentTimeSlotsForPlan } from "@rumble-it/common-lib/types/models/AppointmentTimeSlotsForPlan.interface.ts";
import { axiosInstance } from "@/lib/api/client";

export const getAppointmentTimeSlotsByServicePartner = async (
  servicePartnerId: string,
  companyId: string | null,
  dealershipId: string | null,
) =>
  axiosInstance
    .get<AppointmentTimeSlotsForPlan>(
      `/driver/appointment-time-slots/available-at-service-partner/${servicePartnerId}`,
      {
        params: {
          dossierType: "repair_direct.generic",
          companyId,
          dealershipId,
        },
      },
    )
    .then((response) => response.data);
